<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration.Task'
}
</script>

<style scoped>

</style>
